import request from './httpRequest2'

// 查询文件列表
export function listFiles(query) {
  return request({
    url: '/klgeek/file/list',
    method: 'get',
    params: query
  })
}

// 获取文件详情
export function getFile(id) {
  return request({
    url: `/klgeek/file/${id}`,
    method: 'get'
  })
}

// 新增文件
export function addFile(data) {
  return request({
    url: '/klgeek/file',
    method: 'post',
    data: data
  })
}

// 修改文件
export function updateFile(data) {
  return request({
    url: '/klgeek/file',
    method: 'put',
    data: data
  })
}

// 删除文件
export function delFile(ids) {
  return request({
    url: `/klgeek/file/${ids}`,
    method: 'delete'
  })
}

// 上传文件
export function uploadFile(file, parentId,busId,onProgress,path) {
  const formData = new FormData()
  formData.append('file', file)
  if (parentId) {
    formData.append('parentId', parentId)
  }

  if (busId) {
    formData.append('busId', busId)
  }
  if (path) {
    formData.append('path', path)
  }
  return request({
    url: '/klgeek/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      // 调用传入的进度回调函数
      if (onProgress && typeof onProgress === 'function') {
        onProgress(percentCompleted);
      }
    }
  })
}

// 创建文件夹
export function createFolder(name, parentId,busId,path) {
  const data = {
    name: name,
    busId,
    path
  }
  if (parentId) {
    data.parentId = parentId
  }
  
  return request({
    url: '/klgeek/file/folder',
    method: 'post',
    params: data
  })
}

// 获取文件夹树
export function getFolderTree() {
  return request({
    url: '/klgeek/file/folderTree',
    method: 'get'
  })
}

// 获取文件下载链接
export function getDownloadUrl(id) {
  return process.env.VUE_APP_BASE_API + `/klgeek/file/download/${id}`
}

// 批量上传文件
export function batchUploadFiles(files, parentId, relativePaths, busId, onProgress,path) {
  const formData = new FormData()
  
  files.forEach((file, index) => {
    formData.append('files', file)
  })
  
  if (relativePaths && relativePaths.length > 0) {
    relativePaths.forEach((path, index) => {
      formData.append('relativePaths', path)
    })
  }
  if (path) {
    formData.append('path', path)
  }
  if (parentId) {
    formData.append('parentId', parentId)
  }
  
  if (busId) {
    formData.append('busId', busId)
  }
  
  return request({
    url: '/klgeek/file/batch-upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      // 调用传入的进度回调函数
      if (onProgress && typeof onProgress === 'function') {
        onProgress(percentCompleted);
      }
    }
  })
}

// 批量更新文件业务ID
export function batchUpdateBusId(fileIds, busId) {
  return request({
    url: '/klgeek/file/batch-update-busid',
    method: 'put',
    data: {
      fileIds,
      busId
    }
  })
} 